import { createRoot } from 'react-dom/client';

import { Root } from './root';

const appContainer = document.createElement('div');
document.body.appendChild(appContainer);

const root = createRoot(appContainer);
root.render(<Root />);
